import AppLoader from '../components/Loaders/AppLoader.vue';
import Avatar from '../components/Avatar.vue';
import AvatarMulti from '../components/AvatarMulti.vue';
import BasicLoader from '../components/Loaders/BasicLoader.vue';
import CannedMessages from '../components/CannedMessages.vue';
import CardIcon from '../components/Icon/CardIcon.vue';
import CurrentPassword from '../components/CurrentPassword.vue';
import Dropdown from '../components/Dropdowns/Dropdown.vue';
import DropdownActions from '../components/Dropdowns/DropdownActions.vue';
import FAIcon from '../components/Icon/FAIcon.vue';
import VectorIcon from '../components/Icon/VectorIcon.vue';
import FormActions from '../components/Form/Actions.vue';
import FormButton from '../components/Form/Button.vue';
import FormCheckbox from '../components/Form/Checkbox.vue';
import FormDropdown from '../components/Form/Dropdown.vue';
import FormUpload from '../components/Form/Upload/Upload.vue';
import FormErrorMessage from '../components/Form/ErrorMessage.vue';
import FormInlineEdit from '../components/Form/InlineEdit.vue';
import FormInput from '../components/Form/Input.vue';
import FormMessage from '../components/Form/Message.vue';
import FormRadio from '../components/Form/Radio.vue';
import FormTextarea from '../components/Form/Textarea.vue';
import HeaderSearch from '../components/HeaderSearch.vue';
import MergeFields from '../components/MergeFields.vue';
import MergeFieldsMobile from '../components/MergeFieldsMobile';
import Modal from '../components/Modal.vue';
import ModalSimple from '../components/ModalSimple.vue';
import ModalSteps from '../components/ModalSteps.vue';
import ModalAlertError from '../components/Modal/AlertError.vue';
import ModalAlertSuccess from '../components/Modal/AlertSuccess.vue';
import PickerSimple from '../components/PickerSimple.vue';
import Picker from '../components/Picker.vue';
import ProgressBar from '../components/ProgressBar.vue';
import AwayStatusModal from '../components/AwayStatusModal.vue';
import TenDLCDisabledBanner from '../components/TenDLCDisabledBanner.vue';
import Tooltip from '../components/Tooltip';
import CircleLoader from '../components/Loaders/CircleLoader';
import Tagger from '../components/Tagger.vue';
import Checkbox from '../components/Checkbox';
import Filter from '../components/Filter/Filter';
import FilterColumn from '../components/FilterColumn';
import ToggleButtons from '../components/ToggleButtons';
import vuescroll from 'vuescroll';
import DatePicker from '../components/DatePicker';
import ButtonCircle from '../components/ButtonCircle';
import { ColorPicker } from 'vue-accessible-color-picker';
import LandlineStepper from '../views/Settings/Organization/Numbers/Landline/LandlineStepper';
import ZipwhipStepper from '../views/Settings/Organization/Numbers/Zipwhip/ZipwhipStepper';
import ConfigurationStepper from '../components/ConfigurationStepper';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.css';
import SlideUpDown from 'vue-slide-up-down';
import SliderBar from '../components/SliderBar.vue';
import TextEditor from '../components/Form/Texteditor.vue';
import SearchContacts from '../components/Form/SearchContacts/SearchContacts.vue';
import TextingAssistant from '../components/TextingAssistant.vue';
import SwitchDesignV2 from '../components/SwitchDesignV2';
import Voices from '../components/Voices.vue';

export const GlobalComponents = (Vue) => {
    Vue.component('slider-bar', SliderBar);
    Vue.component('app-loader', AppLoader);
    Vue.component('slide-up-down', SlideUpDown);
    Vue.component('avatar', Avatar);
    Vue.component('avatar-multi', AvatarMulti);
    Vue.component('basic-loader', BasicLoader);
    Vue.component('circle-loader', CircleLoader);
    Vue.component('canned-messages', CannedMessages);
    Vue.component('card-icon', CardIcon);
    Vue.component('current-password', CurrentPassword);
    Vue.component('dropdown', Dropdown);
    Vue.component('dropdown-actions', DropdownActions);
    Vue.component('fa-icon', FAIcon);
    Vue.component('vector-icon', VectorIcon);
    Vue.component('form-actions', FormActions);
    Vue.component('form-button', FormButton);
    Vue.component('form-checkbox', FormCheckbox);
    Vue.component('form-dropdown', FormDropdown);
    Vue.component('form-upload', FormUpload);
    Vue.component('form-error-message', FormErrorMessage);
    Vue.component('form-inline-edit', FormInlineEdit);
    Vue.component('form-input', FormInput);
    Vue.component('form-message', FormMessage);
    Vue.component('form-radio', FormRadio);
    Vue.component('form-textarea', FormTextarea);
    Vue.component('form-search-contacts', SearchContacts);
    Vue.component('header-search', HeaderSearch);
    Vue.component('merge-fields', MergeFields);
    Vue.component('merge-fields-mobile', MergeFieldsMobile);
    Vue.component('modal', Modal);
    Vue.component('modal-simple', ModalSimple);
    Vue.component('modal-steps', ModalSteps);
    Vue.component('modal-alert-error', ModalAlertError);
    Vue.component('modal-alert-success', ModalAlertSuccess);
    Vue.component('picker-simple', PickerSimple);
    Vue.component('picker', Picker);
    Vue.component('progress-bar', ProgressBar);
    Vue.component('away-status-modal', AwayStatusModal);
    Vue.component('ten-d-l-c-disabled-banner', TenDLCDisabledBanner);
    Vue.component('tagger', Tagger);
    Vue.component('tooltip', Tooltip);
    Vue.component('landline-stepper', LandlineStepper);
    Vue.component('zipwhip-stepper', ZipwhipStepper);
    Vue.component('checkbox', Checkbox);
    Vue.component('filter-multi', Filter);
    Vue.component('filter-column', FilterColumn);
    Vue.component('vue-scroll', vuescroll);
    Vue.component('configuration-stepper', ConfigurationStepper);
    Vue.component('toggle-buttons', ToggleButtons);
    Vue.component('date-picker-custom', DatePicker);
    Vue.component('color-picker', ColorPicker);
    Vue.component('multiselect', Multiselect);
    Vue.component('button-circle', ButtonCircle);
    Vue.component('texteditor', TextEditor);
    Vue.component('texting-assistant', TextingAssistant);
    Vue.component('switch-design-v2', SwitchDesignV2);
    Vue.component('voices', Voices);
};
